var React = require('react');

function CheckmarkGrayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 7.40113L11.1061 17.4761C10.502 18.1605 9.45117 18.1766 8.82691 17.5111L4 12.3648L5.49827 10.9171L9.9391 15.6517L18.4593 6L20 7.40113Z","fill":"#818B9E"}));
}

CheckmarkGrayInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckmarkGrayInline;

CheckmarkGrayInline.default = CheckmarkGrayInline;
